// @flow

import React from "react";
import { localize } from "redux-i18n";
import { Modal, ModalHeader, ModalBody, ModalFooter, SchemaForm, Button } from "@components";
import uiSchema from "./__ui__/schema";

type OwnProps = $Exact<{
  onSubmit: (formData: Object) => void,
  onClose: () => void,
}>;

type Props = $Exact<{
  ...OwnProps,
  ...PropsFromLocalize,
}>;

export class AddDepartmentModal extends React.Component<Props> {
  constructor(props: Props) {
    super(props);
    this.formRef = React.createRef();
  }

  submitForm = () => {
    this.formRef.current.submit();
  };

  handleSubmit = (formData: Object) => {
    this.props.onSubmit(formData);
  };

  get schema() {
    return {
      type: "object",
      required: ["organisational_unit_reference", "name"],
      properties: {
        id: {
          type: "integer",
          title: "Department",
        },
        name: {
          type: "string",
          title: "Name",
        },
        organisational_unit_reference: {
          type: "string",
          title: "Organisational Unit Reference",
        },
      },
      urn: "urn:jsonschema:eu:firstcare:api:v2:dto:hierarchy:structure:node:OrganisationalUnitDTO",
    };
  }

  render() {
    return (
      <Modal className="modal-medium">
        <ModalHeader toggle={this.props.onClose}>{this.props.t("ADD_DEPARTMENT")}</ModalHeader>
        <ModalBody>
          <SchemaForm
            className="w-100"
            ref={this.formRef}
            schema={this.schema}
            onSubmit={this.handleSubmit}
            uiSchema={uiSchema}
            externalSubmit
          />
        </ModalBody>
        <ModalFooter className="d-flex justify-content-end">
          <Button color="secondary" onClick={this.props.onClose}>
            {this.props.t("CANCEL")}
          </Button>
          <Button materialIcon="save" onClick={this.submitForm}>
            {this.props.t("SAVE")}
          </Button>
        </ModalFooter>
      </Modal>
    );
  }
}

export default localize()(AddDepartmentModal);
